/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import cx from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';

import { getLogoTitle } from '../../helpers/serviceDeskHelpers';
import { TWILIO_BYOSD_TYPE } from '../../util/channelTypes';

interface TwilioIconMinimalProps {
  className?: string;
  fill?: string;
  size?: number;
}

export const TwilioIconMinimal = ({
  className,
  size = 32,
  ...others
}: TwilioIconMinimalProps) => {
  const intl = useIntl();
  const pxSize = size + 'px';
  return (
    <svg
      className={cx('TwilioIconMinimal', className)}
      viewBox="0 0 32 32"
      width={pxSize}
      height={pxSize}
      fillRule="nonzero"
      xmlns="http://www.w3.org/2000/svg"
      {...others}>
      <title>{getLogoTitle(TWILIO_BYOSD_TYPE, intl)}</title>

      <path d="M16 0C7.147 0 0 7.147 0 16s7.147 16 16 16 16-7.147 16-16S24.853 0 16 0zm0 27.733A11.7 11.7 0 0 1 4.267 16 11.7 11.7 0 0 1 16 4.267 11.7 11.7 0 0 1 27.733 16 11.7 11.7 0 0 1 16 27.733zm7.253-15.68a3.323 3.323 0 0 1-3.306 3.307 3.323 3.323 0 0 1-3.307-3.307 3.323 3.323 0 0 1 3.307-3.306 3.323 3.323 0 0 1 3.306 3.306zm0 7.894a3.323 3.323 0 0 1-3.306 3.306 3.323 3.323 0 0 1-3.307-3.306 3.323 3.323 0 0 1 3.307-3.307 3.323 3.323 0 0 1 3.306 3.307zm-7.893 0a3.323 3.323 0 0 1-3.307 3.306 3.323 3.323 0 0 1-3.306-3.306 3.323 3.323 0 0 1 3.306-3.307 3.323 3.323 0 0 1 3.307 3.307zm0-7.894a3.323 3.323 0 0 1-3.307 3.307 3.323 3.323 0 0 1-3.306-3.307 3.323 3.323 0 0 1 3.306-3.306 3.323 3.323 0 0 1 3.307 3.306z" />
    </svg>
  );
};
